import service from "../service";
import { getApiBaseUrl } from "../config";

export default {
    async getDownloadList(param) {
        const response = await service.get(`${getApiBaseUrl()}download`, param);
        return response;
    },

    async getDownloadNoticeList(param) {
        const response = await service.get(`${getApiBaseUrl()}download/notice`, param);
        return response;
    },

    async getDownload(id) {
        const response = await service.get(
            `${getApiBaseUrl()}download/detail/${id}`
        );
        return response;
    },

    async getFileDownload(filename) {
        // const response = await service.download(
        //     `${getApiBaseUrl()}download/${filename}`,
        //     filename
        // );
        const downloadUrl = `${getApiBaseUrl()}download/${filename}`;
        window.location.href = downloadUrl;
        return downloadUrl;
    },

    async addDownload(download) {
        const response = await service.post(
            `${getApiBaseUrl()}download`,
            download
        );
        return response;
    },

    async updateDownload(download) {
        const response = await service.patch(
            `${getApiBaseUrl()}download`,
            download
        );
        return response;
    },

    async deleteDownload(download_id) {
        const response = await service.delete(
            `${getApiBaseUrl()}download/${download_id}`
        );
        return response;
    },
};
